import styled from 'styled-components';
import { typography } from '@/styles/helpers';

export const ScVipFileUploader = styled.div<{ $hasError?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  min-width: 0;

  & .upload-place {
    flex: 1;
    position: relative;
    display: flex;
    flex-direction: column;
    border: 1px dashed
      ${({ theme, $hasError }) =>
        $hasError ? theme.redColor : theme.grayColor};
    gap: 12px;
    cursor: pointer;
    padding: 24px 16px;
    border-radius: 24px;

    & .upload-icon {
      display: flex;
    }

    & .title-wrapper {
      text-align: left;
      & .title {
        ${typography.body2bold};
        text-transform: none;

        & .info-icon {
          margin-left: 4px;
          vertical-align: baseline;
          opacity: 0.6;
          aspect-ratio: 1/1;
        }
      }
    }

    & .message {
      ${typography.body2regular};
      color: ${({ theme }) => theme.blackLightColor};
      text-align: left;
      margin-top: auto;
      & .link {
        font-weight: 700;
        text-decoration: underline;
        color: ${({ theme }) => theme.color11};

        &:hover {
          color: ${({ theme }) => theme.color10};
        }
      }
    }
  }

  & .selected-item-wrapper {
    display: flex;
    width: 0;
    min-width: 100%;
    gap: 8px;
    align-items: center;
    & .selected {
      flex: 1;
      min-width: 0;
      overflow: hidden;
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 8px;
      background-color: ${({ theme }) => theme.gray1Color};
      border-radius: 20px;
      color: ${({ theme }) => theme.blackColor};
      padding: 0 16px;
      height: 40px;

      & .file-name {
        flex: 1 1 0;
        min-width: 0;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        word-break: break-all;
        text-align: left;
      }

      & .file-size {
        color: ${({ theme }) => theme.blackLightColor};
        flex-shrink: 0;
      }
    }

    & button {
      display: flex;
      padding: 0;
      background: none;
      border: none;
      cursor: pointer;
      color: ${({ theme }) => theme.blackLightColor};
    }
  }

  & .error {
    ${typography.caption1bold};
    color: ${({ theme }) => theme.redColor};
    letter-spacing: 0;
    text-align: left;
    font-weight: 400;
  }
`;
